// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"236d62fd-168":"cb7faa38b47184313cc5","236d62fd-452":"6dbbf9c57ac8b5c42dd9","236d62fd-379":"22201c635d0bfc552c7a","236d62fd-83":"55d3b2c2128a082be4e9"}[chunkId] + ".js";
};